/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTerraConnectionsQueryVariables = Types.Exact<{
  input: Types.ListTerraConnectionsInput;
}>;


export type GetTerraConnectionsQuery = { __typename?: 'Query', listTerraConnections: Array<{ __typename?: 'TerraIntegration', integration: string, image_src?: string | null, name: string, scopes: Array<string>, connection?: { __typename?: 'TerraConnection', terra_connection_id: string, vitall_patient_id: string, integration: string, last_webhook_update?: string | null, is_authenticated: boolean, created_at?: string | null } | null }> };

export type AuthenticateTerraConnectionMutationVariables = Types.Exact<{
  input: Types.PostTerraConnectionInput;
}>;


export type AuthenticateTerraConnectionMutation = { __typename?: 'Mutation', authenticateConnection: { __typename?: 'TerraConnectionSession', terra_connection_id: string, status: string, auth_url: string } };

export type DeauthenticateTerraConnectionMutationVariables = Types.Exact<{
  input: Types.DeleteTerraConnectionInput;
}>;


export type DeauthenticateTerraConnectionMutation = { __typename?: 'Mutation', deauthenticateConnection: boolean };


export const GetTerraConnectionsDocument = gql`
    query getTerraConnections($input: ListTerraConnectionsInput!) {
  listTerraConnections(input: $input) {
    integration
    image_src
    name
    scopes
    connection {
      terra_connection_id
      vitall_patient_id
      integration
      last_webhook_update
      is_authenticated
      created_at
    }
  }
}
    `;
export function useGetTerraConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables> & ({ variables: GetTerraConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>(GetTerraConnectionsDocument, options);
      }
export function useGetTerraConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>(GetTerraConnectionsDocument, options);
        }
// @ts-ignore
export function useGetTerraConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>;
export function useGetTerraConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTerraConnectionsQuery | undefined, GetTerraConnectionsQueryVariables>;
export function useGetTerraConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>(GetTerraConnectionsDocument, options);
        }
export type GetTerraConnectionsQueryHookResult = ReturnType<typeof useGetTerraConnectionsQuery>;
export type GetTerraConnectionsLazyQueryHookResult = ReturnType<typeof useGetTerraConnectionsLazyQuery>;
export type GetTerraConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetTerraConnectionsSuspenseQuery>;
export type GetTerraConnectionsQueryResult = Apollo.QueryResult<GetTerraConnectionsQuery, GetTerraConnectionsQueryVariables>;
export const AuthenticateTerraConnectionDocument = gql`
    mutation authenticateTerraConnection($input: PostTerraConnectionInput!) {
  authenticateConnection(input: $input) {
    terra_connection_id
    status
    auth_url
  }
}
    `;
export type AuthenticateTerraConnectionMutationFn = Apollo.MutationFunction<AuthenticateTerraConnectionMutation, AuthenticateTerraConnectionMutationVariables>;
export function useAuthenticateTerraConnectionMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateTerraConnectionMutation, AuthenticateTerraConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateTerraConnectionMutation, AuthenticateTerraConnectionMutationVariables>(AuthenticateTerraConnectionDocument, options);
      }
export type AuthenticateTerraConnectionMutationHookResult = ReturnType<typeof useAuthenticateTerraConnectionMutation>;
export type AuthenticateTerraConnectionMutationResult = Apollo.MutationResult<AuthenticateTerraConnectionMutation>;
export type AuthenticateTerraConnectionMutationOptions = Apollo.BaseMutationOptions<AuthenticateTerraConnectionMutation, AuthenticateTerraConnectionMutationVariables>;
export const DeauthenticateTerraConnectionDocument = gql`
    mutation deauthenticateTerraConnection($input: DeleteTerraConnectionInput!) {
  deauthenticateConnection(input: $input)
}
    `;
export type DeauthenticateTerraConnectionMutationFn = Apollo.MutationFunction<DeauthenticateTerraConnectionMutation, DeauthenticateTerraConnectionMutationVariables>;
export function useDeauthenticateTerraConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeauthenticateTerraConnectionMutation, DeauthenticateTerraConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeauthenticateTerraConnectionMutation, DeauthenticateTerraConnectionMutationVariables>(DeauthenticateTerraConnectionDocument, options);
      }
export type DeauthenticateTerraConnectionMutationHookResult = ReturnType<typeof useDeauthenticateTerraConnectionMutation>;
export type DeauthenticateTerraConnectionMutationResult = Apollo.MutationResult<DeauthenticateTerraConnectionMutation>;
export type DeauthenticateTerraConnectionMutationOptions = Apollo.BaseMutationOptions<DeauthenticateTerraConnectionMutation, DeauthenticateTerraConnectionMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetTerraConnections = withQueryResponseHandler(useGetTerraConnectionsQuery);
export const useAuthenticateTerraConnection = withMutationResponseHandler(useAuthenticateTerraConnectionMutation, "authenticateTerraConnection");
export const useDeauthenticateTerraConnection = withMutationResponseHandler(useDeauthenticateTerraConnectionMutation, "deauthenticateTerraConnection");